import React from 'react'
import { connect } from 'react-redux'
import color from '../../res/color';
import _ from 'lodash';
import push from 'push.js'
import Switch from "react-switch";
import { withTranslation } from 'react-i18next';
import AnalogClock from 'analog-clock-react';
import ResultPage from '../result/resultPage';
import ElapsedTime from './compornents/elapsedTime';

import { getEmotion } from '../../actions';

import mic1 from '../../res/img/mic0.png';
import mic2 from '../../res/img/mic1.png';
import mic3 from '../../res/img/mic2.png';
import mic4 from '../../res/img/mic3.png';
import mic5 from '../../res/img/mic4.png';
import mic6 from '../../res/img/mic5.png';
import tono1a from '../../res/img/TonoDaruma_01A.gif';
import stylesPc from './styles/analyzePageStyle.js'
import stylesPhone from './styles/analyzePageStyleSmartPhone.js'

var styles;

type Props = {
    duration: Number;
    useAssist: Boolean;
};

type State = {
    count: Number;
    result: String;
    isMeetingStart: Boolean;
    isMeetingFinish: Boolean;
    startTime: Date;
    recording: Boolean;
    calm: Array;
    anger: Array;
    joy: Array;
    sorrow: Array;
    elapsedTime: Number;
    volArray: Array;
    useAssist: Boolean;
    micGauge: Number;
};

let BUFFER = 2048;
var context;
let processor;
let input;
var audioData = [];
let analyser;
var stBt;
let MIN_SPEECH_REC_NUM = 12;
class AnalyzePage extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
        this.startRecord = this.startRecord.bind(this);
        this.getMeetingTime = this.getMeetingTime.bind(this);
        this.handleAssistChange = this.handleAssistChange.bind(this);
        this.state = {
            count: 5,
            speachCount: 0,
            result: "",
            micImage: mic1,
            isMeetingStart: false,
            isMeetingFinish: false,
            startTime: new Date(),
            recording: false,
            stream: undefined,
            calm: [],
            anger: [],
            joy: [],
            sorrow: [],
            elapsedTime: 0,
            volArray: [],
            useAssist: false,
            micGauge: 3,
        };
    }

    componentDidMount() {
        stBt = document.getElementById('start');

        // this.checkPermission();
        this.startStream();

        this.setState({
            useAssist: this.props.useAssist,
        })
    }

    checkPermission(): Function {
        navigator.permissions.query({ name: 'microphone' }).then(function (result) {
            if (result.state === 'granted') {
                return true;
            } else if (result.state === 'prompt') {
                return true;
            } else if (result.state === 'denied') {
                alert("マイクを使用できません");
            }
            result.onchange = function () {
                alert("chenge");
            };
            return true;
        });
    }

    startStream(): Function {
        navigator.mediaDevices
            .getUserMedia({
                audio: {
                    echoCancellation: true,
                    echoCancellationType: 'browser',
                    noiseSuppression: true,
                    sampleRate: { ideal: 11025 },
                }, video: false
            })
            .then((stream) => {
                // Streamを記憶
                this.setStream(stream);

                this.handleStartMeeting();

                stBt.addEventListener("click", () => {
                    if (this.state.isMeetingStart) {
                        this.handleStopMeeting();
                    } else {
                        this.handleStartMeeting();
                    }
                }, false);
            })
            .catch(this.handleFailed);
    }

    setStream(stream) {
        this.setState({
            stream: stream,
        })
    }

    handleStartMeeting(): Function {
        this.setState({
            startTime: new Date(),
            isMeetingStart: true,
        });
        this.startRecord();
    }

    handleFailed(): Function {
        alert("マイクの使用が許可されていません。");
    }

    handleStopMeeting(): Function {
        this.stop();
        this.setState({
            isMeetingStart: false,
            isMeetingFinish: true,
        });
        this.closeMic();
        push.create('会議終了時間です。解析が終わりました。', {
            icon: tono1a,
            timeout: 10000, // 通知が消えるタイミング
            vibrate: [100, 100, 100], // モバイル端末でのバイブレーション秒数
            onClick: function () {
                window.focus();
                this.close();
            }
        });
    }

    // レコード開始
    startRecord(): Function {
        if (!this.state.recording) {
            this.closeMic();
            context = new (window.AudioContext || window.webkitAudioContext)();
            analyser = context.createAnalyser();
            this.setState({
                recording: true,
            });
            processor = context.createScriptProcessor(BUFFER, 1, 1);
            processor.connect(context.destination);

            var source = context.createBufferSource();
            source.connect(processor);

            input = context.createMediaStreamSource(this.state.stream);
            input.connect(processor); // API用録音データコネクション
            input.connect(analyser);
            // audio stream生成
            processor.onaudioprocess = (audio) => {
                this.micAnim();
                var input = audio.inputBuffer.getChannelData(0);
                var bufferData = new Float32Array(BUFFER);

                for (var i = 0; i < BUFFER; i++) {
                    bufferData[i] = input[i];
                }
                audioData.push(bufferData);
            }
            this.recordingTimer();
        }
    }

    recordingTimer(): Function {
        let Interval = setInterval(() => {
            var tmpCount = this.state.count - 1;
            if (!this.state.recording) {
                clearInterval(Interval);
                this.setState({
                    count: 5,
                });
            } else if (tmpCount > 1) {
                this.setState({
                    count: tmpCount,
                });
            } else {
                clearInterval(Interval);
                this.setState({
                    count: 5,
                });
                if (this.state.speachCount > MIN_SPEECH_REC_NUM) {
                    this.stop();
                } else {
                    this.setState({
                        speachCount: 0,
                        recording: false,
                    });
                    this.startRecord();
                }
            }
        }, 1000);
    }

    getMeetingTime(eTime: Number): Function {
        var timing = this.props.duration / 6;
        this.setState({
            elapsedTime: eTime,
        });
        if (eTime >= this.props.duration) {
            this.handleStopMeeting();
        } else if (eTime !== 0 && eTime % timing === 0) {
            this.startRecord();
            if (this.state.useAssist) {
                push.create('そろそろ喋ってみる？', {
                    icon: tono1a,
                    timeout: 8000, // 通知が消えるタイミング
                    vibrate: [100, 100, 100], // モバイル端末でのバイブレーション秒数
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
            }
        }
    }

    stop(): Function {
        if (this.state.recording) {
            let blob = this.exportWAV(audioData); //wavデータ生成
            // 1秒後に送信
            setTimeout(() => {
                this.props.dispatch(getEmotion(blob))
                    .then((data) => {
                        var his = this.state.result + "　(error" + data.error + ", calm:" + data.calm + ", anger:" + data.anger + ", joy:" + data.joy + ", sorrow:" + data.sorrow + ", energy" + data.energy + ")";
                        var tmpCalm = this.state.calm;
                        tmpCalm.push(data.calm);
                        var tmpAnger = this.state.anger;
                        tmpAnger.push(data.anger);
                        var tmpJoy = this.state.joy;
                        tmpJoy.push(data.joy);
                        var tmpSorrow = this.state.sorrow;
                        tmpSorrow.push(data.sorrow);
                        this.setState({
                            count: 5,
                            micImage: mic1,
                            result: his,
                            recording: false,
                            calm: tmpCalm,
                            anger: tmpAnger,
                            joy: tmpJoy,
                            sorrow: tmpSorrow,
                        });
                    })
                    .catch(() => alert("ERR"));
            }, 950);
        }
        this.setState({
            recording: false,
        });
    }

    closeMic(): Function {
        // WebRTCコネクションを閉じる
        if (input != null) input.disconnect();
        if (context != null && !context.isClose) context.close().then(function () {
            audioData = [];
            input = null;
            processor = null;
        }).catch();
        this.setState({
            speachCount: 0,
        });
    }

    exportWAV(audioData): Function {
        let encodeWAV = function (samples, sampleRate) {
            let buffer = new ArrayBuffer(44 + samples.length * 2);
            let view = new DataView(buffer);

            let writeString = function (view, offset, string) {
                for (let i = 0; i < string.length; i++) {
                    view.setUint8(offset + i, string.charCodeAt(i));
                }
            };

            let floatTo16BitPCM = function (output, offset, input) {
                for (let i = 0; i < input.length; i++, offset += 2) {
                    let s = Math.max(-1, Math.min(1, input[i]));
                    output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                }
            };

            writeString(view, 0, 'RIFF');  // RIFFヘッダ
            view.setUint32(4, 32 + samples.length * 2, true); // これ以降のファイルサイズ
            writeString(view, 8, 'WAVE'); // WAVEヘッダ
            writeString(view, 12, 'fmt '); // fmtチャンク
            view.setUint32(16, 16, true); // fmtチャンクのバイト数
            view.setUint16(20, 1, true); // フォーマットID
            view.setUint16(22, 1, true); // チャンネル数
            view.setUint32(24, sampleRate, true); // サンプリングレート
            view.setUint32(28, sampleRate * 2, true); // データ速度
            view.setUint16(32, 2, true); // ブロックサイズ

            // サンプルあたりのビット（入力サンプルレートによって切り替え）
            if (context.sampleRate >= 40000) {
                view.setUint16(34, 54, true);
            } else {
                view.setUint16(34, 16, true);
            }
            writeString(view, 36, 'data'); // dataチャンク
            view.setUint32(40, samples.length * 2, true); // 波形データのバイト数
            floatTo16BitPCM(view, 44, samples); // 波形データ

            return view;
        };

        let mergeBuffers = function (audioData) {
            let sampleLength = 0;
            for (let i = 0; i < audioData.length; i++) {
                sampleLength += audioData[i].length;
            }
            let samples = new Float32Array(sampleLength);
            let sampleIdx = 0;
            for (let i = 0; i < audioData.length; i++) {
                for (let j = 0; j < audioData[i].length; j++) {
                    samples[sampleIdx] = audioData[i][j];
                    sampleIdx++;
                }
            }
            return samples;
        };

        let dataview = encodeWAV(mergeBuffers(audioData), 11025);
        let audioBlob = new Blob([dataview], { type: 'audio/wav' });
        // let myURL = window.URL || window.webkitURL;
        // let url = myURL.createObjectURL(audioBlob);
        return audioBlob;
    };

    onMinusMicSensitivity(): Function {
        if (this.state.micGauge < 10) {
            this.setState({
                micGauge: this.state.micGauge + 1,
            })
        }
    }

    onPlusMicSensitivity(): Function {
        if (this.state.micGauge > 1) {
            this.setState({
                micGauge: this.state.micGauge - 1,
            })
        }
    }

    // マイク録音音量取得
    getVolume(): Function {
        var bit8 = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(bit8);

        return bit8.reduce(function (previous, current) {
            return previous + current;
        }) / analyser.frequencyBinCount;
    };

    micAnim(): Function {
        var vol = this.getVolume();
        var image = mic1;
        var newArray = this.state.volArray;
        let mag = 5;
        if (vol < (this.state.micGauge * mag)) {
            image = mic1;
        } else if (vol >= (this.state.micGauge * mag) && vol < 10 + (this.state.micGauge * mag)) {
            image = mic2;
            newArray.push(vol);
            this.setState({
                speachCount: this.state.speachCount + 1,
                volArray: newArray,
            });
        } else if (vol >= 10 + (this.state.micGauge * mag) && vol < 20 + (this.state.micGauge * mag)) {
            image = mic3;
            newArray.push(vol);
            this.setState({
                speachCount: this.state.speachCount + 1,
                volArray: newArray,
            });
        } else if (vol >= 20 + (this.state.micGauge * mag) && vol < 30 + (this.state.micGauge * mag)) {
            image = mic4;
            newArray.push(vol);
            this.setState({
                speachCount: this.state.speachCount + 1,
                volArray: newArray,
            });
        } else if (vol >= 30 + (this.state.micGauge * mag) && vol < 45 + (this.state.micGauge * mag)) {
            image = mic5;
            newArray.push(vol);
            this.setState({
                speachCount: this.state.speachCount + 1,
                volArray: newArray,
            });
        } else if (vol >= 45 + (this.state.micGauge * mag)) {
            image = mic6;
            newArray.push(vol);
            this.setState({
                speachCount: this.state.speachCount + 1,
                volArray: newArray,
            });
        }
        this.setState({
            micImage: image,
        });
    }

    getSpeechProportion(): Function {
        var totalVolCount = this.state.volArray.length;
        return _.floor((totalVolCount / 23) / 60, 0);
    }

    handleAssistChange(useAssist) {
        this.setState({ useAssist });
    }

    render() {
        styles = this.props.screenwidth > 400 * 2 ? stylesPc : stylesPhone;
        // const { t, i18n } = this.props
        return this.state.isMeetingFinish ?
            (<ResultPage
                calm={this.state.calm}
                joy={this.state.joy}
                anger={this.state.anger}
                sorrow={this.state.sorrow}
                meetingTime={this.state.elapsedTime}
                volArray={this.state.volArray}
            />)
            : (
                <div style={styles.main}>
                    <div style={styles.sideFrame}>
                        <p style={styles.sideTitleText}>会議時間</p>
                        <div style={styles.sideTitleBorder} />
                        <div style={styles.meetingTimeFrame}>
                            <div style={styles.clockFrame}>
                                <AnalogClock {...styles.clock} />
                            </div>
                            <ElapsedTime
                                getMeetingTime={this.getMeetingTime}
                                isStart={this.state.isMeetingStart}
                                startTime={this.state.startTime} />
                            <p style={styles.sideText}>経過</p>
                        </div>

                        <p style={styles.sideTitleText}>発言時間</p>
                        <div style={styles.sideTitleBorder} />
                        <div style={styles.speakTimeFrame}>
                            <p style={styles.speakTime}>{this.getSpeechProportion()}</p>
                            <p style={styles.sideText}>分</p>
                        </div>
                        <button id="start" style={styles.bt}>{!this.state.isMeetingStart ? "開始" : "終了"}</button>
                    </div>

                    <div style={styles.mainFrame}>
                        <div style={styles.header}>

                            <div style={styles.headerContentFrame}>
                                <p style={styles.headerText}>発言アシスト</p>
                                <p style={styles.assistStateText}>{this.state.useAssist ? "アシスト中" : "アシストオフ"}</p>
                                <Switch
                                    onColor={color.empathBlue}
                                    offColor={color.empathPink}
                                    onChange={this.handleAssistChange}
                                    checked={this.state.useAssist} />
                                {/* <div style={styles.result}>{this.state.result}</div> */}
                            </div>

                            <div style={styles.headerContentFrame}>
                                <p style={styles.headerText}>マイク感度</p>
                                <div style={styles.micGaugeFrame}>
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 10 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 9 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 8 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 7 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 6 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 5 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 4 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 3 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 2 ? color.themeColor : color.transparent, }])} />
                                    <div style={Object.assign({}, ...[styles.micGauge, { background: this.state.micGauge === 1 ? color.themeColor : color.transparent, }])} />
                                </div>
                                <div style={styles.micButtonFrame}>
                                    <button style={styles.micButton} onClick={() => this.onMinusMicSensitivity()}>-</button>
                                    <button style={styles.micButton} onClick={() => this.onPlusMicSensitivity()}>+</button>
                                </div>
                                {/* <div style={styles.result}>{this.state.result}</div> */}
                            </div>

                            {/* <div style={styles.headerContentFrame}>
                                <div style={styles.iconFrame}>
                                    <img id="listenIcon" alt="listenIcon" type="image" src={listenIcon} />
                                    <p style={styles.iconText}>相槌回数</p>
                                </div>
                                <div style={styles.result}>{"Rec: " + this.state.recording}{" Mtg: " + this.state.isMeetingStart}</div>
                                <p style={styles.extentionText}>回</p>
                            </div> */}

                        </div>
                        <div style={styles.contentFrame}>
                            <img
                                id="tono"
                                alt="tono"
                                type="image"
                                style={styles.tono}
                                src={tono1a} />
                            <div style={styles.analyzingText}>診断中...</div>
                            <img
                                id="mic"
                                alt="mic"
                                type="image"
                                style={styles.mic}
                                src={this.state.micImage} />
                        </div>
                    </div>
                </div>
            );
    }
}

const mapStateToProps = state => ({
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(withTranslation()(AnalyzePage))